import { render, staticRenderFns } from "./AgreementPost.vue?vue&type=template&id=dda04f98&"
import script from "./AgreementPost.vue?vue&type=script&lang=js&"
export * from "./AgreementPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports